import { TimeWindowsSkeleton } from 'components/TimeWindow';
import { PropsWithChildren } from 'react';

interface Props {
  isLoading?: boolean;
  preloadComponents?: boolean;
}

export function LoadingWrapper({
  isLoading,
  preloadComponents = true,
  children,
}: PropsWithChildren<Props>) {
  if (!preloadComponents && isLoading) {
    return <TimeWindowsSkeleton />;
  }

  return (
    <>
      {isLoading ? <TimeWindowsSkeleton /> : null}{' '}
      <div
        style={{
          display: isLoading ? 'none' : 'block',
        }}
      >
        {children}
      </div>
    </>
  );
}
